import React, { useRef, useEffect, useState } from "react";
import { motion, AnimationControls } from "framer-motion";

interface HandDrawnCircleProps {
  controls: AnimationControls;
  duration?: number;
  delay?: number;
}

const HandDrawnCircle: React.FC<HandDrawnCircleProps> = ({
  controls,
  duration = 1,
  delay = 0.3,
}) => {
  const pathRef = useRef<SVGPathElement>(null);
  const [pathLength, setPathLength] = useState(0);

  useEffect(() => {
    if (pathRef.current) {
      const length = pathRef.current.getTotalLength();
      setPathLength(length);
    }
  }, []);

  const drawVariants = {
    hidden: {
      pathLength: 0,
    },
    visible: {
      pathLength: 1,
      transition: {
        pathLength: {
          type: "tween",
          duration: duration,
          delay: delay,
          ease: "easeInOut",
        },
      },
    },
  };

  return (
    <svg
      width="784"
      height="551"
      viewBox="0 0 784 551"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="w-[54.06vw] h-auto max-lg:w-[107vw]"
    >
      <motion.path
        ref={pathRef}
        d="M605.823 422.638C317.564 516.969 -16.5467 261.504 81.5669 113.387C179.68 -34.7287 527.811 -29.3968 701.58 166.411C869.886 356.062 730.329 532.463 432.671 540.706C206.52 546.968 89.3316 450.681 10.0003 385.242"
        stroke="#CFB2FF"
        strokeWidth="20"
        strokeMiterlimit="10"
        strokeLinecap="round"
        variants={drawVariants}
        initial="hidden"
        animate={controls}
        style={{
          pathLength: pathLength,
        }}
      />
    </svg>
  );
};

export default HandDrawnCircle;
